import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, IconName } from '../icons';

export interface RelatedLinkItem {
  key: string;
  label: string;
  icon?: IconName;
  /** Interner Pfad (react-router). */
  to?: string;
  /** Externe Adresse, oeffnet in neuem Tab. */
  href?: string;
  /** Vorhanden (gefuellt) oder noch offen (gestrichelt). Standard: vorhanden. */
  done?: boolean;
  title?: string;
}

export interface RelatedLinksProps {
  items: RelatedLinkItem[];
  /** Beschriftung fuer Screenreader, z. B. "Verknüpft mit Idee X". */
  label?: string;
  className?: string;
}

/**
 * Zeile kleiner Sprung-Chips zu allem, was an einem Datensatz haengt.
 * Offene Punkte sind gestrichelt und fuehren dorthin, wo man sie anlegt.
 */
export const RelatedLinks: React.FC<RelatedLinksProps> = ({ items, label = 'Verknüpft', className }) => (
  <nav className={`ui-related${className ? ` ${className}` : ''}`} aria-label={label}>
    {items.map((item) => {
      const cls = `ui-related__chip${item.done === false ? ' ui-related__chip--open' : ''}`;
      const inner = (
        <>
          {item.icon && <Icon name={item.icon} size={13} aria-hidden="true" />}
          <span>{item.label}</span>
        </>
      );
      if (item.href) {
        return (
          <a key={item.key} className={cls} href={item.href} target="_blank" rel="noopener noreferrer" title={item.title}>
            {inner}
          </a>
        );
      }
      return (
        <Link key={item.key} className={cls} to={item.to ?? '#'} title={item.title}>
          {inner}
        </Link>
      );
    })}
  </nav>
);
